// @ts-nocheck

import Vue from "vue";

export default Vue.extend({
  methods: {
    generatePassword() {
        var length = 16,
          charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
          retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
      },
      showSnack(text:any,timeout:any){
        this.snackbar.text = text;
        this.snackbar.timeout = timeout || 2000;
        this.snackbar.visible = true;
      },
      openCollapse() {
        $("body").toggleClass("collapse-open");
      },
      closeCollapse() {
        $("body").removeClass("collapse-open");
      }
  }
});